import {stringify} from 'qs'
import {format} from 'utils'
import request from 'crm/utils/request'
import api from './api'

export async function list(params) {
    return request(`${api.list.url}${stringify(params, {addQueryPrefix: true})}`)
}

export async function remove(payload) {
    return request(format(api.remove.url, {id: payload.id}), {
        method: api.remove.type,
    })
}

export async function taskConfig() {
    return request(api.taskConfig.url)
}

export async function updateTaskConfig(payload) {
    return request(api.updateTaskConfig.url, {
        method: api.updateTaskConfig.type,
        body: payload.body,
    })
}

export async function publish(payload) {
    return request(format(api.publish.url, {id: payload.taskId}), {
        method: api.publish.type,
        body: payload.body,
    })
}

export async function exportData(params) {
    return request(`${api.exportData.url}${stringify(params, {addQueryPrefix: true})}`, null, {
        returnResponse: true,
    })
}

// 导出引流物料
export async function exportDrainageData(payload) {
    return request(format(api.exportDrainageData.url, {id: payload.id}), null, {
        returnResponse: true,
    })
}
